import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../utils/Button';
import ShoppingTable from '../components/ClientPortal/shoppingTable';
import Select from '../utils/FormElements/select';
import Confetti from 'react-confetti';
import { useSelector, useDispatch } from 'react-redux';
import { setItemCount, setAddToCart, setActiveAddressId, resetCartItem, setCartAdded, setAllKitsforSite } from '../Store/reducers/orders';
import OrderDataTable from '../components/ClientPortal/orderTable';

import { getAllAddresses, createNewOrder, getAllOrdersAction, getAvailabeKitsAction, getAllCountries } from '../Actions/orders';
import { editFormReducer, setForm } from '../Store/reducers/uiSettings';
import { BuyIcon, DateIcon, HomeIcon, FileIcon, Next, CrossIcon, Add, Confirm, Address, SelectDownArrow } from '../HemeIconLibrary';
import FormContainer from '../components/Formik/formContainer';
import { Formik } from 'formik';
import LoginInput from '../utils/FormElements/loginInput';
import { HemaLabel } from '../utils';

import { Spinner } from 'react-bootstrap';
import { Alert as BootstrapAlert } from 'react-bootstrap';
import { Alert } from '../utils';
import { eachDayOfInterval } from 'date-fns';
import BackCmp from '../components/BackCmp';
import { Tab, Tabs } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const addWorkDays = (startDate, days) => {
  if (isNaN(days)) {
    console.log('Value provided for "days" was not a number');
    return;
  }
  if (!(startDate instanceof Date)) {
    console.log('Value provided for "startDate" was not a Date object');
    return;
  }
  // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
  var dow = startDate.getDay();
  var daysToAdd = parseInt(days);
  // If the current day is Sunday add one day
  if (dow == 0) daysToAdd++;
  // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
  if (dow + daysToAdd >= 6) {
    //Subtract days in current working week from work days
    var remainingWorkDays = daysToAdd - (5 - dow);
    //Add current working week's weekend
    daysToAdd += 2;
    if (remainingWorkDays > 5) {
      //Add two days for each working week by calculating how many weeks are included
      daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
      //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
      if (remainingWorkDays % 5 == 0) daysToAdd -= 2;
    }
  }
  startDate.setDate(startDate.getDate() + daysToAdd);
  return startDate;
};

const Checkout = () => {
  const {
    orders,
    uisettings,
    user: { activeSite },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
console.log(orders)
  const changeQuantity = (data, count) => {
    dispatch(setItemCount({ data: data, count: count }));
    dispatch(setCartAdded(true));
  };
  const [activeAddress, setActiveAddress] = useState();
  const [orderplaced, setOrderPlaced] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [successNotifiation, setSuccessNotifiation] = useState('');
  const [activeTab, setActiveTab] = useState();

  const navigate = useNavigate();
  const minDate = addWorkDays(new Date(), 5);

  //
  const formikRef = useRef();

  const addToCart = (data, status) => {
    const getCartItemsFromLocal = localStorage.getItem('cart-item-ids');

    if (status === true) {
      localStorage.setItem('cart-item-ids', [getCartItemsFromLocal, data.id]);
    } else {
      localStorage.setItem(
        'cart-item-ids',
        getCartItemsFromLocal.split(',')?.filter((id) => id !== String(data.id)),
      );
    }
    dispatch(setAddToCart({ data, status }));
  };

  useEffect(() => {
    setActiveAddress(orders.addresses?.[0]);
    getAllCountries();
  }, [orders.addresses]);

  useEffect(() => {
    if (activeSite) {
      getAllAddresses(activeSite?.id);
    }
  }, [activeSite]);

  useEffect(() => {
    showConfetti &&
      setTimeout(() => {
        setShowConfetti(false);
      }, 5000);
  }, [showConfetti]);

  const countWeekdays = (startDate, endDate) => {
    const days = eachDayOfInterval({ start: startDate, end: endDate });
    return days.filter((day) => !isWeekend(day)).length;
  };

  const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6; // 0 is Sunday, 6 is Saturday
  };

  const isPastDay = (date) => {
    const today = new Date();
    return date < today;
  };

  return (
    <>
      {showConfetti && <Confetti tweenDuration={5000} />}
      <div className="max-w-[1440px] relative w-full min-h-screen mx-auto pt-[92px] md:pt-[100px] px-4 md:px-10 pb-5 mb-0 md:mb-[85px] ">
        <div className="flex items-center">
          <BackCmp />
          <Link to="/" className="font-medium text-[13px] leading-6 text-black hover:text-primary1 m-0 no-underline">
            Home
          </Link>
          <div className=" w-[2px] h-3 bg-black mx-1" />
          <Link to="/collection" className=" no-underline  font-medium text-[13px] leading-6 text-black m-0">
            Collection Kits
          </Link>
          <div className=" w-[2px] h-3 bg-black mx-1" />
          <h5 className="font-medium text-[13px] leading-6 text-primary1 m-0">Checkout</h5>
        </div>
        {orderplaced ? (
          <div>
            <Alert />
            <BootstrapAlert variant="success">
              Thank you for your order! Your order has been received and is currently being processed. Your order confirmation number is <strong> {successNotifiation}</strong>.
              {/* <div
              className="underline cursor-pointer w-fit bold"
              onClick={() => {
                dispatch(setForm({ state: true, type: 'share-order' }));
              }}
            >
              <strong>Click here</strong>
            </div> */}
            </BootstrapAlert>

            {/* <OrderDataTable data={orders?.allOrders || []} /> */}
            <div className="bg-white rounded-[5px] px-[10px] py-[15px] mt-[27px] mb-[13px] inventory-tabs">
              <Tabs
                defaultActiveKey="All"
                id="uncontrolled-tab-example"
                className=""
                onSelect={(key) => {
                  setActiveTab(key);
                }}
              >
                <Tab eventKey="All" title={<div className="flex items-center title-icon">All</div>}>
                  <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Order History For This Site</h3>

                  <OrderDataTable data={orders.allOrders || []} />
                </Tab>
                {!!orders.allOrders?.filter((status) => status.status.id === 1)?.length && (
                  <Tab eventKey="Recieved" title={<div className="flex items-center title-icon">New</div>}>
                    <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Order History For This Site</h3>

                    <OrderDataTable data={orders.allOrders?.filter((status) => status.status.id === 1) || []} />
                  </Tab>
                )}
                {!!orders.allOrders?.filter((status) => status.status.id === 2)?.length && (
                  <Tab eventKey="In Process" title={<div className="flex items-center title-icon">In Process</div>}>
                    <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Order History For This Site</h3>

                    <OrderDataTable data={orders.allOrders?.filter((status) => status.status.id === 2) || []} />
                  </Tab>
                )}
                {!!orders.allOrders?.filter((status) => status.status.id === 3)?.length && (
                  <Tab eventKey="Shipped" title={<div className="flex items-center title-icon">Shipped</div>}>
                    <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Order History For This Site</h3>

                    <OrderDataTable data={orders.allOrders?.filter((status) => status.status.id === 3) || []} />
                  </Tab>
                )}
                {!!orders.allOrders?.filter((status) => status.status.id === 4)?.length && (
                  <Tab eventKey="Delivered" title={<div className="flex items-center title-icon">Delivered</div>}>
                    <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Order History</h3>

                    <OrderDataTable data={orders.allOrders?.filter((status) => status.status.id === 4) || []} />
                  </Tab>
                )}
              </Tabs>
              <div className="ml-auto w-fit mt-7">
                <div className="">
                  <div className="flex items-center gap-4 xsm:gap-6 flex-wrap">
                    <Link to="/collection">
                      <Button text="Continue Shopping" type="button" bg="bg-primary1" color="text-white" Icon={<BuyIcon width={'20'} height={'20'} />} />
                    </Link>
                    <Button
                      type="submit"
                      text={'Go Home'}
                      bg="bg-primary1"
                      color="text-white"
                      Icon={<HomeIcon color="#FFFFFF" />}
                      cta={() => {
                        navigate('/');
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <Alert type="error" />
            <br />
            <div className="w-full min-h-[100px] pt-[20px] px-[25px] pb-[20px] bg-white shadow-mdShadow mb-[30px] collection-card">
              <h3 className="font-bold text-xl leading-6 text-black mb-[10px]">Shopping Cart</h3>

              <ShoppingTable data={orders.allKitsforSite?.filter((kit) => kit.addtocart) || []} changeQuantity={changeQuantity} addToCart={addToCart} />
            </div>

            <div className="w-full  pt-[23px] px-[23px] pb-4 bg-white shadow-mdShadow mb-[30px]">
              <h3 className="font-bold text-xl leading-6 text-black mb-[26px]">Shipping Details</h3>
              <div className="">
                <Formik
                  initialValues={{
                    address: '',

                    date: '',

                    notes: '',
                  }}
                  innerRef={formikRef}
                  enableReinitialize
                  validate={(values) => {
                    const errors = {};
                    if (!values.date) {
                      errors.date = 'Required';
                    }

                    if (!values.address) {
                      errors.address = 'Required';
                    }

                    if (values.date) {
                      const currentDate = new Date();
                      const needDate = new Date(values.date);
                      const diffTime = Math.abs(currentDate - needDate);
                      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                      var weekdays = countWeekdays(currentDate, needDate);
                      if (isWeekend(needDate)) {
                        errors.date = 'You can not select a weekend day';
                      } else if (weekdays - 1 < 5) {
                        errors.date = 'Need By Date should be atleast 5 working days from today.';
                      }
                    }

                     if (values.address && values.address.id && values.address.id !== 'addnew') {
                    const addr = (orders.addresses || []).find(a => a.id === values.address.id);
                    if (addr) {
                      const over = [];
                      const lim = {
                        name: 35,
                        address1: 35,
                        address2: 35,
                        department: 35,
                        city: 35,
                        stateProvince: 30,
                        postalCode: 10,
                        email: 50,
                        phone: 15,
                      };
                      const len = v => (v ?? '').toString().trim().length;
                      const check = (key, label) => { if (len(addr[key]) > lim[key]) over.push(`${label} (max ${lim[key]})`); };

                      check('name', 'Name');
                      check('address1', 'Address 1');
                      check('address2', 'Address 2');
                      check('department', 'Department');
                      check('city', 'City');
                      check('stateProvince', 'State/Province');
                      check('postalCode', 'Zip/Postal Code');
                      check('email', 'Email');
                      check('phone', 'Phone Number');

                      if (over.length) {
                        errors.address = `The selected address exceeds character limits for: ${over.join(', ')}. Please edit this address in the Address Book before continuing.`;
                      }
                    }
                  }

                    return errors;
                  }}
                  onSubmit={async (values, { setSubmitting }) => {
                    console.log(values);

                    const orderNew = await createNewOrder({
                      addressId: values?.address?.id,
                      siteId: activeSite?.id,
                      neededDate: values.date,
                      note: values.notes,
                      items: orders.allKitsforSite
                        ?.filter((kit) => kit.addtocart)
                        .map((data) => {
                          return { id: data.id, quantity: data.count || 1 };
                        }),
                    });
                    // Check for error in response
                    if (orderNew?.status !== 200) {
                      dispatch({
                        type: "uiSettings/showErrorReducer",
                        payload: orderNew?.message || "An error occurred while placing your order.",
                      });
                      setSubmitting(false);
                      return;
                    }

                    const kits = orders.allKitsforSite?.map((data) => {
                      return { ...data, count: 0 };
                    });
                    dispatch(setAllKitsforSite(kits));
                    localStorage.setItem('cart-item-ids', '');
                    await getAllOrdersAction(activeSite.id);
                    setOrderPlaced(true);
                    setShowConfetti(true);
                    dispatch(resetCartItem());
                    dispatch(setSuccessNotifiation(orderNew?.data?.orderCode));

                    getAvailabeKitsAction(activeSite.id);
                    // setSuccessNotifiation(orderNew?.data?.orderCode);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    isValid,
                    isValidating,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    isSubmitting,
                    /* and other goodies */
                  }) => (
                    <>
                      <form onSubmit={handleSubmit} className="shopping_cart_form shipping-form">
                        <div className="w-full flex items-start gap-[0] md:gap-[16px] justify-between flex-col md:flex-row">
                          <div className="w-full flex flex-col mb-7">
                            <HemaLabel required text="Shipping Address" Icon={<Address color="#775FD5" />} textSize="text-[12px]" />
                            <Select
                              formikRef={formikRef}
                              position="!top-[13px]"
                              setFieldValueFull={(name, value) => {
                                console.log(value);
                                if (value?.id === 'addnew') {
                                  dispatch(editFormReducer());
                                  dispatch(
                                    setForm({
                                      state: true,
                                      type: 'add-address-book',
                                    }),
                                  );
                                } else {
                                  setFieldValue('address', value);
                                }
                              }}
                              dropIcon={<SelectDownArrow />}
                              name="address"
                              placeholder="Choose a shipping address"
                              crossIcon={values.address ? <CrossIcon /> : ''}
                              setFieldValue={setFieldValue}
                              options={[
                                ...(orders.addresses || []).map((addr) => {
                                  const name = addr?.name ? addr.name + ' | ' : '';
                                  const email = addr?.email ? addr.email + ' | ' : '';
                                  return {
                                    id: addr.id,
                                    name: name + email + addr.address1 + ', ' + addr.city + ' ' + addr.stateProvince + ' ' + addr.country.name + '.',
                                    icon: <Address color="#775FD5" />,
                                  };
                                }),
                                {
                                  id: 'addnew',
                                  name: 'Add New Address',
                                  icon: <Add color="#775FD5" />,
                                },
                              ]}
                            />

                            {errors.address && touched.address && <p className="error m-0  text-[#F54C3B]">{errors.address}</p>}
                          </div>

                          <div className="w-full relative flex flex-col mb-7">
                            <HemaLabel required text="Needed by Date" Icon={<DateIcon />} textSize="text-[12px]" />
                            {/* <div className="w-full"> */}
                            <div className="date_div">
                              <DatePicker
                                minDate={minDate}
                                className="w-full bg-[#fff] mt-[10px] py-[17px] pl-[10px] font-medium text-[12px] leading-[15px] border border-[#DEE2E6] rounded-[5px]"
                                placeholderText="Choose a date you want this order by"
                                selected={values.date}
                                onChange={(date) => {
                                  formikRef?.current?.setFieldTouched('date', true);
                                  setFieldValue('date', date);
                                }}
                                filterDate={(date) => !isWeekend(date) && !isPastDay(date)}
                              />
                              <p className="absolute top-[20px] right-[9px] cursor-pointer">
                                <DateIcon />
                              </p>
                            </div>
                            {values.date && (
                              <p onClick={() => setFieldValue('date', '')} className={`absolute  top-[43px] right-[29px] cursor-pointer`}>
                                <CrossIcon />
                              </p>
                            )}

                            {errors.date && touched.date && <p className="error m-0  text-[#F54C3B]">{errors.date}</p>}
                          </div>
                        </div>
                        <div className="max-w-full md:max-w-[649px] flex flex-col mb-7">
                          <HemaLabel text="Order Notes/Special Instructions" Icon={<FileIcon color="#605DAF" />} textSize="text-[12px]" />
                          <LoginInput
                            type="textarea"
                            name="notes"
                            placeholder="Enter order note"
                            value={values.notes}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            setFieldValue={setFieldValue}
                          />
                          <p className="error m-0  text-[#F54C3B]">{errors.notes && touched.notes && errors.notes}</p>
                        </div>
                        <div className="ml-auto w-fit">
                          <div className="">
                            <div className="flex items-center gap-4 xsm:gap-6 flex-wrap">
                              <Link to="/collection">
                                <Button text="Continue Shopping" type="button" bg="bg-primary1" color="text-white" Icon={<BuyIcon width={'20'} height={'20'} />} />
                              </Link>
                              {isSubmitting ? (
                                <Button type="button" text="Submit Order" bg="bg-primary1" color="text-white" Icon={<Spinner size="sm" variant="light" />} />
                              ) : orders.allKitsforSite?.filter((kit) => kit.addtocart)?.length ? (
                                <Button
                                  text="Submit Order"
                                  bg="bg-primary1"
                                  color="text-white"
                                  Icon={<Confirm />}
                                  type="submit"
                                  disabled={values.address && values.address !== 'addnew' && values.date ? false : true}
                                />
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                </Formik>
              </div>
            </div>
          </>
        )}
      </div>
      {uisettings?.openform && <FormContainer />}
    </>
  );
};

export default Checkout;
